import { environment } from 'src/environments/environment';

/**
 * The collection ids an image search is scoped to.
 *
 * Five endpoints ask the same question of three different back ends — the
 * exclusive creativeSearch and editorialSearch, and the three
 * api.indiapicture.in search scripts — and each built its `coll_id` its own way.
 * Two of them sent nothing at all, so the same words returned different
 * libraries depending on which one answered.
 *
 * `environment.serachCollections` is the shared default (the spelling is the
 * one already in the environment files). Written once here rather than as a
 * `|| environment.serachCollections` at each call site, because three copies of
 * a default is how three call sites stop agreeing.
 *
 * A caller's OWN list still wins. A collection filter the customer chose, or the
 * collections their plan covers, is a narrower and more correct answer than the
 * site-wide default — this only fills the gap where nothing was supplied.
 *
 * @param supplied the caller's collections: a csv string, an array of ids, or
 *                 nothing at all
 */
export function searchCollections(supplied?: string | number[] | null): string {
    if (Array.isArray(supplied)) {
        return supplied.length ? supplied.join(',') : environment.serachCollections;
    }

    const csv = (supplied || '').toString().trim();

    return csv !== '' ? csv : environment.serachCollections;
}
